import { flatten, sortBy, cloneDeep } from 'lodash';
import { types } from './componentsdb.js';
import Partutil from './partutil.js';
import Treeutil from './treeutil.js';
import Searcher from './searcher.js';
import availableQuicktweens from './quicktweens.js';

function Animator(gamedata, partutil, minDuration=3, maxDuration=99999) {
  this.gamedata = gamedata;
  this.partutil = partutil;
  this.treeutil = new Treeutil(this.partutil.from);
  this.searcher = new Searcher(this.gamedata);
  this.mutators =  {};
  this.maxDuration = maxDuration;
  this.minDuration = minDuration;
  this.enterEntries = {};
  this.exitEntries = {};
}
Animator.prototype.isPopulated = function (component) {
  if (component.type === 'text') {
    return (component.text||'').trim() !== "";
  }
  return true;
}
Animator.prototype.getSpritesAndTextes = function () {
  return this.partutil.findChildrenFromTransform(this.partutil.root)
    .filter( (transform) => {
      const component = this.partutil.getComponentById(transform.cid);
      return ['sprite', 'text', 'toy', 'video'].includes(component.type) && this.isPopulated(component);
    });
}
Animator.prototype.getAllTimelines = function () {
  if (this.gamedata.gamedata.game.timelimit === -1) {
    return {
      duration:-1,
      timeline:[],
      undo:{
        duration:-1,
        timeline:[]
      }
    }
  }
  //const transforms = this.gamedata.findAllTransforms();
  //let transforms = this.searcher.findTransformsForTypes(['sprite', 'text']);
  let transforms = this.getSpritesAndTextes();
  transforms = transforms.filter( (d) => {
    //return d.transform.layer === 'default' || d.transform.layer === 'text' || d.transform.layer === 'toy';
    return d.transform.layer !== 'background' && d.transform.layer !== 'meme_template';
  });

  const timelines = transforms.map(this.getTimelineForTransform.bind(this));
  return this.mergeTimelines(...timelines);
}

Animator.prototype.findEnterTweenComponent = function (transform) {
  const component = this.partutil.findComponentForTransform(transform);
  const {components} = this.partutil.findComponentsAndLinksFrom(component);
  const tweenComponents = components.filter( ({type}) => {
    return type === 'tween';
  });

  if (tweenComponents.length) {
    tweenComponents[0].__animator = 'enter';
    return tweenComponents[0];
  } else {
    const tween = types.tween.createNew();
    if (transform.transform.layer === 'text') {
      tween.tweens = [
        //availableQuicktweens.filter( ({name,tags}) => {
          //return name === 'Fade In Half'
        //})[0]
      ];
    } else if (transform.transform.layer === 'toy') {
      tween.tweens = [
        availableQuicktweens.filter( ({name,tags}) => {
          return name === 'Zoom In'
        })[0]
      ];
    } else {
      tween.tweens = [];
    }
    tween.tags = ['enter'];
    const {addedComponents} = this.treeutil.addComponentWithLinkData(component,
      {name:'link'},
      tween
    );

    this.partutil.buildComponentCache();
    const tweenComponent = addedComponents[0];
    tweenComponent.__animator = 'enter';
    return tweenComponent;

  }
}

Animator.prototype.findExitDelayComponent = function (transform) {
  const component = this.partutil.findComponentForTransform(transform);
  const {components} = this.partutil.findComponentsAndLinksFrom(component);
  const delayComponents = components.filter( ({type,...rest}) => {
    return type === 'delay' && rest.__animator == 'exit';
  });

  if (delayComponents.length) {
    return delayComponents[0];
  } else {
    const delay = types.delay.createNew();
    delay.delay = this.minDuration - 0.5;
    const {addedComponents} = this.treeutil.addComponentWithLinkData(component,
      {name:'link'},
      delay
    );
    this.partutil.buildComponentCache();

    const delayComponent = addedComponents[0];
    delayComponent.__animator = 'exit';
    return delayComponent;
  }
}


Animator.prototype.findExitTweenComponent = function (transform, sourceDelay) {
  const component = this.partutil.findComponentForTransform(transform);
  const {components} = this.partutil.findComponentsAndLinksFrom(component);
  const tweenComponents = components.filter( ({type,...rest}) => {
    return type === 'tween' && rest.__animator == 'exit';
  });

  if (tweenComponents.length) {
    return tweenComponents[0];
  } else {
    const tween = types.tween.createNew();
    if (transform.transform.layer === 'text') {
      tween.tweens = [
        //availableQuicktweens.filter( ({name,tags}) => {
          //return name === 'Fade Out Half'
        //})[0]
      ];
    } else if (transform.transform.layer === 'toy') {
      tween.tweens = [
        availableQuicktweens.filter( ({name,tags}) => {
          return name === 'Zoom Out'
        })[0]
      ];
    } else {
      tween.tweens = [];
    }

    tween.tags = ['exit'];
    const {addedComponents} = this.treeutil.addComponentWithLinkData(sourceDelay,
      {name:'link'},
      tween
    );
    this.partutil.buildComponentCache();

    const tweenComponent = addedComponents[0];
    tweenComponent.__animator = 'exit';
    return tweenComponent;
  }
}

Animator.prototype.findTimelineComponent = function (transform) {
  const component = this.partutil.findComponentForTransform(transform);
  const {components} = this.partutil.findComponentsAndLinksFrom(component);
  const timelineComponents = components.filter( ({type,...rest}) => {
    return type === 'timeline' && rest.__animator == 'timeline';
  });

  if (timelineComponents.length) {
    return timelineComponents[0];
  } else {
    const timelineComponent = types.timeline.createNew();
    const {addedComponents} = this.treeutil.addComponentWithLinkData(
      component,
      {name:'link'},
      timelineComponent
    );
    const timeline = addedComponents[0];

    this.partutil.buildComponentCache();

    timeline.__animator = 'timeline';
    timeline.name = "__animator";
    return timeline;
  }
}


Animator.prototype.addTimelineEntryForTransform = function (transform, fromEvent) {
  const timelineComponent = this.findTimelineComponent(transform);
  //const timelineComponent = this.getTimelineForTransform(transform);

  let newComponent;
  if (fromEvent.copyFromCid) {
    const sourceComponent = this.partutil.getComponentById(fromEvent.copyFromCid);
    if (sourceComponent) {
      newComponent = cloneDeep(sourceComponent);
    }
  }
  if (!newComponent) {
    newComponent = types.move.createNew();
  }
  const {addedLinks,addedComponents} = this.treeutil.addComponentWithLinkData(
    timelineComponent,
    {name:'at',
      meta:{
        t:fromEvent.start + fromEvent.duration
      }
    },
    newComponent
  )
  this.partutil.buildComponentCache();
  return {addedLinks,addedComponents}
}

Animator.prototype.getEnterOrExitLabel = function (component) {
  if (!component.tweens || !component.tweens.length) {
    return "None";
  } else {
    return component.tweens.map ( (t) => {
      return t.name;
    }).join("\n");
  }
}

Animator.prototype.getTimelineForTransform = function (transform) {
  const tweenComponent = this.findEnterTweenComponent(transform);
  const startDelay = typeof((transform.vars||{}).delay) !== 'undefined' ? transform.vars.delay : 0;
  const enterEntry = {
    id:[transform.id, tweenComponent.id].join('-'),
    tid:transform.id,
    cid:tweenComponent.id,
    start: startDelay,
    duration: tweenComponent.time,
    __type: 'enter',
    label: this.getEnterOrExitLabel(tweenComponent)
  }
  this.enterEntries[transform.id] = enterEntry;

  this.setMutators(enterEntry, this.createEnterMutator(enterEntry, tweenComponent, transform));

  const exitDelayComponent = this.findExitDelayComponent(transform);
  const exitTweenComponent = this.findExitTweenComponent(transform, exitDelayComponent);

  const exitDelay = exitDelayComponent.delay + this.enterEntries[transform.id].start;
  const exitDuration = exitTweenComponent.time;

  const exitEntry = {
    id:[transform.id, exitDelayComponent.id].join('-'),
    tid:transform.id,
    cid:exitTweenComponent.id,
    start:exitDelay,
    duration:exitDuration,
    __type: 'exit',
    label: this.getEnterOrExitLabel(exitTweenComponent)
  }
  this.exitEntries[transform.id] = exitEntry;
  this.setMutators(exitEntry, this.createExitMutator(exitEntry, exitDelayComponent, exitTweenComponent, transform));

  const thisDuration = Math.max(
    enterEntry.start + enterEntry.duration,
    exitEntry.start + exitEntry.duration
  );

  const duration = Math.min(
    this.maxDuration, 
    Math.max(
      thisDuration,
      this.minDuration
    )
  );

  const timelineComponent = this.findTimelineComponent(transform);
  const timelineEntries = this.findTimelineEntriesForTimelineComponent(transform, timelineComponent);

  return {
    duration,
    timeline:[enterEntry, ...timelineEntries, exitEntry]
  }

  /*
  return {
    duration:3,
    timeline:[enterEntry]
  }
  */


}
Animator.prototype.findDurationForComponent = function (transform, component, link) {
  if (component.type === 'move') {
    return component.t;
  } else if (component.type === 'tween') {
    if (component.flip) {
      return component.time*2;
    } else {
      return component.time;
    }
  } else if (component.type === 'automove') {
    return link.meta.d;
  } else {
    return 1;
  }
}
Animator.prototype.findTimelineEntriesForTimelineComponent = function (transform, timelineComponent) {
  // start,duration
  const {links,components} = this.partutil.findComponentsAndLinksFrom(timelineComponent);

  const entries = [];
  links.forEach( (link) => {
    const {target,meta,name} = link;
    /*
    id:[transform.id, tweenComponent.id].join('-'),
    tid:transform.id,
    cid:tweenComponent.id,
    start: startDelay,
    duration: tweenComponent.time,
    label: 'Enter'
    */

    if (name !== 'link' && meta && typeof(meta.t) !== 'undefined') {
      const component = components.filter( ({id}) => {
        return target === id;
      })[0];

      const entry = {
        id:[transform.id, component.id].join('-'),
        tid:transform.id,
        cid:component.id,
        start:meta.t,
        duration:this.findDurationForComponent(transform, component, link),
        label:component.__quick || component.type,
        __type:'animation'
      }
      entries.push(entry);

      this.setMutators(entry, this.createTimelineMutators(entry, component, link, transform));

    }
  });


  return entries;
}
Animator.prototype.createTimelineMutators = function (entry, component, link, transform) {
  return {
    setStart: (timeline, nv) => {
      const enters = timeline.timeline.filter( ({label,tid,__type}) => {
        return tid === transform.id && __type === 'enter';
      });
      if (enters.length) {
        const enter = enters[0];
        if (nv < enter.start) {
          nv = enter.start;
        }
      }

      link.meta.t = nv - this.enterEntries[transform.id].start;
      entry.start = nv;

    },
    setDuration: (timeline, nv) => {
      if (component.type === "move") {
        component.t = nv;
        delete link.meta.d;
      } else if (component.type === "tween") {
        if (component.flip) {
          component.time = nv/2;
        } else {
          component.time = nv;
        }
        delete link.meta.d;
      } else if (component.type === 'automove') {
        link.meta.d = nv;
      }
      entry.duration = nv;

    }
  }

}

Animator.prototype.mergeTimelines = function (...timelines) {
  const duration = Math.max(this.minDuration, ...timelines.map( ({duration}) => {
    return duration;
  }));
  const mergedTimelines = flatten(timelines.map( ({timeline}) => {
    return timeline;
  }));
  const sortedTimelines = sortBy(mergedTimelines, ({start}) => {
    return start;
  });
  return {
    duration,
    timeline:sortedTimelines,
    undo:{
      duration,
      timeline:cloneDeep(sortedTimelines)
    }
  }
}

Animator.prototype.setMutators = function (entry, {setStart,setDuration}) {
  this.mutators[entry.id] = {
    setStart,
    setDuration
  }
}

Animator.prototype.hasDelay = function (transform) {
  const parents = this.partutil.getParentsForTransform(transform);
  const parentComponents = [this.partutil.root].concat(parents).map( (transform) => {
    return this.partutil.findComponentForTransform(transform);
  }).filter( (c) => { return !!c });
  return parentComponents.filter( ({type}) => {
    return type === 'delayTransform'
  }).length;
}
Animator.prototype.addDelayToTransform = function (transform) {
  const delay = types.delayTransform.createNew();
  this.partutil.addParentToTransform(transform, delay);
}

Animator.prototype.createEnterMutator = function (entry, component, transform) {
  return {
    setStart: (timeline, nv) => {
      if (nv > 0) {
        if (!this.hasDelay(transform)) {
          this.addDelayToTransform(transform);
        }
      }
      const exits = timeline.timeline.filter( ({label,tid,__type}) => {
        return tid === transform.id && __type === 'exit';
      });
      if (exits.length) {
        const exit = exits[0];
        if (nv > exit.start) {
          nv = exit.start - 0.1;
          entry.duration = 0.1;
        }
      }

      transform.vars.delay = nv;
      entry.start = nv;

      const exitDelayComponent = this.findExitDelayComponent(transform);
      exitDelayComponent.delay = this.exitEntries[transform.id].start - entry.start;


    },
    setDuration: (timeline, nv) => {
      const exits = timeline.timeline.filter( ({label,tid,__type}) => {
        return tid === transform.id && __type === 'exit';
      });
      if (exits.length) {
        const exit = exits[0];
        if (nv + entry.start > exit.start) {
          nv = exit.start - entry.start;
        }
      }
      component.time = nv;
      entry.duration = nv;

    }
  }
}

Animator.prototype.createExitMutator = function (entry, delayComponent, tweenComponent, transform) {
  return {
    setStart: (timeline, nv) => {
      const enters = timeline.timeline.filter( ({label,tid,__type}) => {
        return tid === transform.id && __type === 'enter';
      });
      if (enters.length) {
        const enter = enters[0];
        if (nv < enter.start + enter.duration) {
          nv = enter.start + enter.duration;
        }
      }

      delayComponent.delay = nv - this.enterEntries[transform.id].start;
      entry.start = nv;


    },
    setDuration: (timeline, nv) => {
      tweenComponent.time = nv;
    }
  }
}

Animator.prototype.getUndoData = function (timeline) {
  return cloneDeep(timeline.undo);
}
Animator.prototype.makeUndoData = function (timeline) {
  timeline.undo = {
    duration:timeline.duration,
    timeline:cloneDeep(timeline.timeline)
  }
}

Animator.prototype.updateTimelineEntry = function (timeline, entry) {
  const undoData = this.getUndoData(timeline);
  console.log('update timeline', JSON.stringify(undoData, 0, 2));
  this.mutators[entry.id].setStart(timeline, entry.start);
  this.mutators[entry.id].setDuration(timeline, entry.duration);
  this.makeUndoData(timeline);
  return undoData;
}

Animator.prototype.extendDuration = function (timeline, duration) {
  const undo = this.getUndoData(timeline);
  const oldDuration = timeline.duration;
  timeline.timeline.forEach( (entry) => {
    const end = entry.start + entry.duration;
    if (Math.abs(end - oldDuration) < 0.05) {
      entry.start = duration - entry.duration;
      this.updateTimelineEntry(timeline, entry);
    }
  });
  timeline.duration = duration;
  this.makeUndoData(timeline);
  return {timeline,undo};
}

Animator.prototype.getAfterEnterAutomove = function (transform, create=false) {
  const component = this.partutil.findComponentForTransform(transform);
  const {components} = this.partutil.findComponentsAndLinksFrom(component);
  const automoveComponents = components.filter( ({type}) => {
    return type === 'automove';
  });

  if (automoveComponents.length) {
    return automoveComponents[0];
  } else {
    if (!create) {
      return undefined;
    }
    const automove = types.automove.createNew();
    automove.dx = 1;
    automove.dy = 0;
    automove.__animator = 'automove';
    const {addedComponents} = this.treeutil.addComponentWithLinkData(component,
      {name:'link'},
      automove
    );
    this.partutil.buildComponentCache();
    return addedComponents[0];

  }

}

Animator.prototype.refreshMutators = function (timeline) {
  timeline.timeline.forEach( (entry) => {
    this.mutators[entry.id].setStart(timeline, entry.start);
    this.mutators[entry.id].setDuration(timeline, entry.duration);
  });

}
Animator.prototype.undoUpdate = function (timeline, undoData) {
  const redoData = this.getUndoData(timeline);
  console.log('REDO WIL LBE', JSON.stringify(redoData,0,2));
  Object.assign(timeline.timeline, undoData.timeline);
  timeline.duration = undoData.duration;
  timeline.undo = undoData;
  this.refreshMutators(timeline);
  return redoData;
}

Animator.prototype.redoUpdate = function (timeline, redoData) {
  const undoData = this.getUndoData(timeline);
  Object.assign(timeline.timeline, redoData.timeline);
  timeline.duration = redoData.duration;
  timeline.undo = redoData;
  this.refreshMutators(timeline);
  return undoData;
}

export default Animator;

